export default "__VITE_ASSET__MdTv$QFJ__"